/**
 * ShortlistRankingBadge — one-line inline chip that shows the uni's
 * BEST leaderboard position (if any). Sits alongside the CAO/UCAS
 * deadline chips on a shortlist row so families see the "why" at a
 * glance without a full hero card.
 *
 * Falls back to null when the uni has no top-20 appearance — the
 * shortlist row layout is self-hiding.
 */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Trophy } from "lucide-react";
import { subjectSlug } from "@/lib/rankingSlug";

export default function ShortlistRankingBadge({ uniId, testid }) {
  const [top, setTop] = useState(null);
  useEffect(() => {
    if (!uniId) return;
    api
      .get(`/rankings/uni-appearances/${uniId}?top_n=20`)
      .then((r) => setTop((r.data.appearances || [])[0] || null))
      .catch(() => setTop(null));
  }, [uniId]);

  if (!top) return null;

  const isPodium = top.rank <= 3;
  return (
    <Link
      to={`/rankings/${top.country.toLowerCase()}/${subjectSlug(top.subject)}`}
      data-testid={testid || `shortlist-rank-badge-${uniId}`}
      className={
        "inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-underground-sc tracking-wider transition-colors " +
        (top.rank === 1
          ? "bg-amber-100 text-amber-900 border border-amber-300 hover:bg-amber-200"
          : isPodium
          ? "bg-[#F5F0FF] text-[#4C1D95] border border-[#4C1D95]/30 hover:border-[#4C1D95]"
          : "bg-stone-100 text-stone-700 border border-stone-300 hover:border-stone-500")
      }
    >
      <Trophy className="h-2.5 w-2.5" />
      #{top.rank} · {top.subject}
    </Link>
  );
}
